import styled from 'styled-components'

import { DASHBOARD_STYLED_CONSTS } from '@components'
import { Colors, mediaQueries } from '@fourthwall/components'

export const Container = styled.div<{ $isOpen: boolean }>`
  width: 100%;
  height: ${DASHBOARD_STYLED_CONSTS.HEADER_HEIGHT}px;
  background: ${Colors.GS300};

  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 10;

  // NOTE: 155px is there because we push the bar additional 100px top to make it not visible on Safari after scrolling above fold
  transform: ${({ $isOpen }) => ($isOpen ? 'translateY(0)' : 'translateY(-155px)')};
  transition: transform 0.2s;

  display: flex;
`

export const LogoContainer = styled.div`
  display: none;
  color: red;

  ${mediaQueries.laptop} {
    width: ${DASHBOARD_STYLED_CONSTS.SIDEBAR_WIDTH}px;
    padding: 0 24px;

    display: flex;
    align-items: center;
  }
`

export const Content = styled.div`
  max-width: 888px;
  padding: 0 20px;
  margin: 0 auto;
  box-sizing: content-box;

  flex: 1;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  ${mediaQueries.laptop} {
    padding: 0 ${DASHBOARD_STYLED_CONSTS.CONTENT_PADDING_HORIZONTAL_LAPTOP}px;
  }
`

export const Message = styled.div`
  flex: 1;

  color: ${Colors.GS1000};
`
